// Escapes '<' so serialized JSON can't be broken out of its enclosing <script> tag
// by content (e.g. a job description or CMS copy) that happens to contain "</script>".
export const stringifyJsonLd = (data: unknown): string =>
  JSON.stringify(data).replace(/</g, '\\u003c');

// Resolves a page-relative path against an origin into an absolute URL. Already-absolute
// paths are returned unchanged, so callers can pass through an external href untouched.
export const resolveUrl = (origin: string, path: string): string => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const cleanOrigin = origin.replace(/\/+$/, '');
  return `${cleanOrigin}${path.startsWith('/') ? path : `/${path}`}`;
};
